import React from 'react';
import { MarketCodeSchema } from '@schuettflix/utils';
import { MarketContextProvider, useMarketContext } from '@/shared/context/MarketContext.tsx';
import { HttpClientContextProvider } from '@/shared/context/HttpClientContext.tsx';
import { OrderPage } from '@/modules/order/OrderPage.tsx';
import { PositionLoader, PositionLoaderComponentProps } from '@/routes/loaders/PositionLoader.tsx';
import { MessageBox } from '@schuettflix/react-components';
type InnerOrderRouteProps = PositionLoaderComponentProps;

function InnerOrderRoute({ positionV2 }: InnerOrderRouteProps) {
    const { marketCode: contextMarketCode } = useMarketContext();
    const marketCode = positionV2 ? MarketCodeSchema.parse(positionV2.marketCode) : contextMarketCode;

    if (positionV2 && positionV2.status === 'CLOSED') {
        return (
            <MessageBox type="error" title="Error">
                Ordering against a CLOSED position is not allowed. position: {positionV2.number}
            </MessageBox>
        );
    }

    return (
        <MarketContextProvider marketCode={marketCode}>
            <HttpClientContextProvider marketCode={marketCode}>
                <OrderPage positionV2={positionV2} />
            </HttpClientContextProvider>
        </MarketContextProvider>
    );
}

export const OrderRoute = PositionLoader(InnerOrderRoute);
